import React, { useContext, useEffect, useState } from "react"; // eslint-disable-line no-unused-vars
import { makeStyles } from "@material-ui/core/styles";
import { State } from "../../store/state";
import {
  Grid,
  TextField,
  Button,
  Typography,
  MenuItem,
  Divider,
} from "@material-ui/core";
import * as consts from "../../consts";
import { updateCart } from "../../store/actions";

export default function PlasticQuote({ quote }) {
  const useStyles = makeStyles((theme) => ({
    items: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginBottom: theme.spacing(2),
    },
    shippingInputs: {
      marginTop: theme.spacing(2),
    },
    cardImage: {
      backgroundRepeat: "no-repeat",
      backgroundColor: "#ffffff",
      [theme.breakpoints.up("md")]: {
        borderRadius: "14px",
      },
      [theme.breakpoints.down("sm")]: {
        borderRadius: "4px",
      },
      border: "1px solid #d8d8d8",
      backgroundSize: "cover",
      overflow: "hidden",
    },
    overlay: {
      width: "100%",
      display: "block",
    },
    cardCommands: {
      padding: "0px !important",
    },
    textButton: {
      padding: "8px",
      minWidth: "initial",
      "&:hover": {
        color: "rgba(0, 0, 0, 0.87)",
      },
    },
    details: {
      padding: "10px",
      margin: "5px",
      backgroundColor: "#fafafa",
      borderRadius: "4px",
      "& > div": {
        padding: "4px",
      },
    },
    subtotal: {
      textAlign: "right",
    },
  }));
  const classes = useStyles();
  const { state, dispatch } = useContext(State);
  const [showDetails, setShowDetails] = useState([]);

  let plasticMeCartItems = quote.filter((item) => {
    return (
      item.cardType == consts.CARD_TYPE_PLASTIC &&
      (item.mailOption == consts.PLASTIC_TYPE_ME ||
        item.mailOption == consts.PLASTIC_TYPE_NO_CARRIER)
    );
  });

  // let plasticNoCarrierCartItems = quote.filter((item) => {
  //   return (
  //     item.cardType == consts.CARD_TYPE_PLASTIC &&
  //     item.mailOption == consts.PLASTIC_TYPE_NO_CARRIER
  //   );
  // });

  let plasticThemCartItems = quote.filter((item) => {
    return (
      item.cardType == consts.CARD_TYPE_PLASTIC &&
      item.mailOption == consts.PLASTIC_TYPE_THEM
    );
  });

  const convertToMoney = (value) => {
    let decPlaces = 2;
    let decSep = ".";
    let thouSep = ",";
    var sign = value < 0 ? "-$" : "$";
    var i = String(
      parseInt((value = Math.abs(Number(value) || 0).toFixed(decPlaces)))
    );
    var j = (j = i.length) > 3 ? j % 3 : 0;
    return (
      sign +
      (j ? i.substr(0, j) + thouSep : "") +
      i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
      (decPlaces
        ? decSep +
          Math.abs(value - i)
            .toFixed(decPlaces)
            .slice(2)
        : "")
    );
  };

  const renderPlasticMeCards = () => {
    if (plasticMeCartItems && plasticMeCartItems.length > 0) {
      return (
        <Grid item container xs={12}>
          <Grid item xs={12}>
            <Typography variant="h5" color="primary">
              Mail to Me
            </Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} className={classes.shippingInputs}>
            <TextField
              className={classes.input}
              required={true}
              fullWidth={true}
              select={true}
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              label="Shipping Method"
              value={plasticMeCartItems[0].cardDetails[0].shipping.method}
              onChange={(event) => {
                let updatedCartItems = plasticMeCartItems.map((cartItem) => {
                  let cardDetails = [...cartItem.cardDetails];
                  cardDetails.map((cardDetail) => {
                    cardDetail.shipping.method = event.target.value;
                    let selectedShipping = cardDetail.shipping.shipMethods.find(
                      (shipMethod) => {
                        return shipMethod.id == event.target.value;
                      }
                    );
                    cardDetail.cardFee.shippingHandling = selectedShipping.cost;
                  });
                  return { ...cartItem, cardDetails: cardDetails };
                });
                let cart = state.cart.filter((cartItem) => {
                  let updatedCartItem = updatedCartItems.find(
                    (updatedCartItem) => {
                      return updatedCartItem.cartItemID == cartItem.cartItemID;
                    }
                  );
                  return updatedCartItem == null;
                });
                cart = [...cart, ...updatedCartItems];
                updateCart(cart, dispatch);
              }}
            >
              {plasticMeCartItems[0].cardDetails[0].shipping.shipMethods.map(
                (shippingMethod, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={shippingMethod.id}
                      style={{ whiteSpace: "break-spaces" }}
                    >
                      {`${shippingMethod.title.replace(
                        "~",
                        "\n"
                      )} - ${convertToMoney(shippingMethod.rate)}`}
                    </MenuItem>
                  );
                }
              )}
            </TextField>
          </Grid>
          <Grid item container xs={12} spacing={2} className={classes.items}>
            {plasticMeCartItems.map((cartItem) => {
              return (
                <React.Fragment key={cartItem.cartItemID}>
                  <Grid item xs={4}>
                    <div
                      className={classes.cardImage}
                      style={{
                        backgroundImage: "url('" + cartItem.cardImage + "')",
                      }}
                    >
                      <img
                        className={classes.overlay}
                        src={`${consts.BLOB_URL}images/CardOverlayNoCorners.png`}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={8} className={classes.subtotal}>
                    <Typography variant="body1" component="div">
                      <span>{cartItem.cardDetails.length}</span>
                      <span>&nbsp;x&nbsp;</span>
                      <span>
                        <b>{convertToMoney(cartItem.cardValue)}</b>
                      </span>
                    </Typography>
                    <Typography variant="body1" component="div">
                      <span>{cartItem.cardDetails.length}</span>
                      <span>&nbsp;x&nbsp;</span>
                      <span>
                        <b>
                          {convertToMoney(
                            cartItem.cardDetails[0].cardFee.productionFee
                          )}
                        </b>
                      </span>
                    </Typography>
                  </Grid>
                  {cartItem.mailOption == consts.PLASTIC_TYPE_NO_CARRIER && (
                    <Grid item xs={12}>
                      <Typography variant="body1" component="div">
                        Plastic Card Only - No Notecard
                      </Typography>
                    </Grid>
                  )}
                  <Grid item xs={12} className={classes.cardCommands}>
                    {!state.quoteid && (
                      <React.Fragment>
                        <Button
                          onClick={() => {
                            window.location.href =
                              "/shop?cartItemID=" + cartItem.cartItemID;
                          }}
                          className={classes.textButton}
                        >
                          Edit
                        </Button>
                        &nbsp;|&nbsp;
                        <Button
                          onClick={() => {
                            if (
                              confirm(
                                "Are you sure you want to remove this item from your cart?"
                              )
                            ) {
                              let cart = state.cart.filter((item) => {
                                return item.cartItemID != cartItem.cartItemID;
                              });
                              updateCart(cart, dispatch);
                            }
                          }}
                          className={classes.textButton}
                        >
                          Remove
                        </Button>
                        &nbsp;|&nbsp;
                      </React.Fragment>
                    )}
                    <Button
                      onClick={() => {
                        let updatedShowDetails = [...showDetails];
                        let showDetailsIndex = updatedShowDetails.indexOf(
                          cartItem.cartItemID
                        );
                        if (showDetailsIndex > -1) {
                          updatedShowDetails.splice(showDetailsIndex, 1);
                        } else {
                          updatedShowDetails.push(cartItem.cartItemID);
                        }
                        setShowDetails(updatedShowDetails);
                      }}
                      className={classes.textButton}
                    >
                      Details
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    {showDetails.indexOf(cartItem.cartItemID) > -1 ? (
                      <Typography variant="body1" component="div">
                        {cartItem.cardDetails.map((cardDetail, index) => {
                          return (
                            <div key={index} className={classes.details}>
                              <div>
                                <div>
                                  To:&nbsp;
                                  {cardDetail.to ? cardDetail.to : <i>Empty</i>}
                                </div>
                                <div>
                                  From:&nbsp;
                                  {cardDetail.from ? (
                                    cardDetail.from
                                  ) : (
                                    <i>Empty</i>
                                  )}
                                </div>
                              </div>
                              <div>
                                {cardDetail.message ? (
                                  <div>Message:&nbsp;{cardDetail.message}</div>
                                ) : (
                                  <div>
                                    Message:&nbsp;<i>Empty</i>
                                  </div>
                                )}
                              </div>
                              <div>
                                <div>Send To:</div>
                                <div>{cardDetail.shipping.name}</div>
                                <div>{cardDetail.shipping.company}</div>
                                <div>{cardDetail.shipping.address}</div>
                                <div>
                                  {cardDetail.shipping.city}&nbsp;
                                  {cardDetail.shipping.state},&nbsp;
                                  {cardDetail.shipping.zip}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </Typography>
                    ) : null}
                  </Grid>
                </React.Fragment>
              );
            })}
          </Grid>
        </Grid>
      );
    } else {
      return null;
    }
  };
  const renderPlasticThemCards = () => {
    if (plasticThemCartItems && plasticThemCartItems.length > 0) {
      return (
        <Grid item container xs={12}>
          <Grid item xs={12} className={classes.title}>
            <Typography variant="h5" color="primary">
              Mail to Recipient
            </Typography>
            <Divider />
          </Grid>
          <Grid item container xs={12} spacing={2}>
            {plasticThemCartItems.map((cartItem) => {
              return (
                <React.Fragment key={cartItem.cartItemID}>
                  <Grid item xs={12}>
                    <TextField
                      className={classes.input}
                      required={true}
                      fullWidth={true}
                      select={true}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                      label="Shipping Method"
                      value={cartItem.cardDetails[0].shipping.method}
                      onChange={(event) => {
                        let cardDetails = [...cartItem.cardDetails];
                        cardDetails.map((cardDetail) => {
                          cardDetail.shipping.method = event.target.value;
                          let selectedShipping =
                            cardDetail.shipping.shipMethods.find(
                              (shipMethod) => {
                                return shipMethod.id == event.target.value;
                              }
                            );
                          cardDetail.cardFee.shippingHandling =
                            selectedShipping.cost;
                        });
                        let updatedCartItem = {
                          ...cartItem,
                          cardDetails: cardDetails,
                        };
                        let cart = state.cart.map((cartItem) => {
                          if (
                            updatedCartItem.cartItemID == cartItem.cartItemID
                          ) {
                            return updatedCartItem;
                          } else {
                            return { ...cartItem };
                          }
                        });
                        updateCart(cart, dispatch);
                      }}
                    >
                      {state.shippingMethods.map((shippingMethod, index) => {
                        return (
                          <MenuItem
                            key={index}
                            value={shippingMethod.id}
                            style={{ whiteSpace: "break-spaces" }}
                          >
                            {`${shippingMethod.title.replace(
                              "~",
                              "\n"
                            )} - ${convertToMoney(shippingMethod.cost)} x ${
                              cartItem.cardDetails.length
                            }`}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Grid>
                  <Grid item xs={4}>
                    <div
                      className={classes.cardImage}
                      style={{
                        backgroundImage: "url('" + cartItem.cardImage + "')",
                      }}
                    >
                      <img
                        className={classes.overlay}
                        src={`${consts.BLOB_URL}images/CardOverlayNoCorners.png`}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={8} className={classes.subtotal}>
                    <Typography variant="body1" component="div">
                      <span>{cartItem.cardDetails.length}</span>
                      <span>&nbsp;x&nbsp;</span>
                      <span>
                        <b>{convertToMoney(cartItem.cardValue)}</b>
                      </span>
                    </Typography>
                    <Typography variant="body1" component="div">
                      <span>{cartItem.cardDetails.length}</span>
                      <span>&nbsp;x&nbsp;</span>
                      <span>
                        <b>
                          {convertToMoney(
                            cartItem.cardDetails[0].cardFee.productionFee
                          )}
                        </b>
                      </span>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} className={classes.cardCommands}>
                    {!state.quoteid && (
                      <React.Fragment>
                        <Button
                          onClick={() => {
                            window.location.href =
                              "/shop?cartItemID=" + cartItem.cartItemID;
                          }}
                          className={classes.textButton}
                        >
                          Edit
                        </Button>
                        &nbsp;|&nbsp;
                        <Button
                          onClick={() => {
                            if (
                              confirm(
                                "Are you sure you want to remove this item from your cart?"
                              )
                            ) {
                              let cart = state.cart.filter((item) => {
                                return item.cartItemID != cartItem.cartItemID;
                              });
                              updateCart(cart, dispatch);
                            }
                          }}
                          className={classes.textButton}
                        >
                          Remove
                        </Button>
                        &nbsp;|&nbsp;
                      </React.Fragment>
                    )}
                    <Button
                      onClick={() => {
                        let updatedShowDetails = [...showDetails];
                        let showDetailsIndex = updatedShowDetails.indexOf(
                          cartItem.cartItemID
                        );
                        if (showDetailsIndex > -1) {
                          updatedShowDetails.splice(showDetailsIndex, 1);
                        } else {
                          updatedShowDetails.push(cartItem.cartItemID);
                        }
                        setShowDetails(updatedShowDetails);
                      }}
                      className={classes.textButton}
                    >
                      Details
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    {showDetails.indexOf(cartItem.cartItemID) > -1 ? (
                      <Typography variant="body1" component="div">
                        {cartItem.cardDetails.map((cardDetail, index) => {
                          return (
                            <div key={index} className={classes.details}>
                              <div>
                                <div>
                                  To:&nbsp;
                                  {cardDetail.to ? cardDetail.to : <i>Empty</i>}
                                </div>
                                <div>
                                  From:&nbsp;
                                  {cardDetail.from ? (
                                    cardDetail.from
                                  ) : (
                                    <i>Empty</i>
                                  )}
                                </div>
                              </div>
                              <div>
                                {cardDetail.message ? (
                                  <div>Message:&nbsp;{cardDetail.message}</div>
                                ) : (
                                  <div>
                                    Message:&nbsp;<i>Empty</i>
                                  </div>
                                )}
                              </div>
                              <div>
                                <div>Send To:</div>
                                <div>{cardDetail.shipping.name}</div>
                                <div>{cardDetail.shipping.company}</div>
                                <div>{cardDetail.shipping.address}</div>
                                <div>
                                  {cardDetail.shipping.city}&nbsp;
                                  {cardDetail.shipping.state},&nbsp;
                                  {cardDetail.shipping.zip}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </Typography>
                    ) : null}
                  </Grid>
                </React.Fragment>
              );
            })}
          </Grid>
        </Grid>
      );
    } else {
      return null;
    }
  };

  return (
    <React.Fragment>
      {renderPlasticMeCards()}
      {/* {renderPlasticNoCarrierCards()} */}
      {renderPlasticThemCards()}
    </React.Fragment>
  );
}
